module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "basic-text-frame"
  }, [_c('div', {
    staticClass: "frame"
  }, [_c('img', {
    staticClass: "frame2",
    attrs: {
      "alt": "119645.png",
      "src": "OEBPS/image/119645.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext1"
  }, [_c('span', {
    staticClass: "testimonial-body"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "chapterheader"
  }, [_c('span', {
    staticClass: "chapterheader1"
  }, [_vm._v("Chapter 5")])])]), _vm._v(" "), _c('div', {
    staticClass: "basic-text-frame"
  }, [_c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("The next morning, before I opened, I made sure I went by Gracie’s Quilt shop to get white fabric and plenty of red floss for my wine country quilt. My mind was spinning with ideas for the blocks, but I’d have to find designs to outline since I couldn’t draw well. Susan had talked us all into buying light boxes a while back, so I was glad I had one to help me. I was about to leave for Gracie’s shop when my landline rang.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Is this Lily Rosenthal?” a female voice asked.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Yes, it is. How can I help you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“My name is Jenny Jordon, and I now live in your old apartment on The Hill.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Oh my goodness. It’s nice to know who’s living there. I’ve driven by on occasion, wondering.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I tracked you down with the help of the current landlord. Evidently, he had records from the lady who previously owned the place when you were a tenant. I understand that she died here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Yes, sweet Bertie Maxwell. She was such a dear!”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Well, I found something that belongs to you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Really? I thought I’d gotten everything out, and I worked so hard to leave it clean.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Yes, the place was spotless, but when I recently went up to the attic, I found some things. Did you ever go up there?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“No, not at all. That was where Bertie stored things. I only rented the second floor.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Well, this landlord is letting me store some things up there because it’s available. The guy downstairs is elderly and doesn’t use it.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Was it creepy up there?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("She chuckled. “It was dirty, that’s for sure. The previous landlord had left some furniture up there, which surprised me. She also had a trunk with a few things inside. There was quilt top that had a note attached. It was addressed to you, like she meant to give it to you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Really?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I didn’t think too much about it, but it did get my curiosity going as to what the story behind it might be. The quilt is nothing fancy. It appears to be made from scraps. There were unfinished crocheted pieces as well. I’ll likely pitch most of what I found, but this quilt top had been assigned to someone. That’s why I asked my landlord about who was here and when.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Oh, Jenny, please hang on to that for me. Bertie knew I loved quilts, but I know she was upset with me when I told her I was leaving. She wouldn’t even speak to me for a while. She said I was like a daughter to her, so it was hard for her to imagine me moving so far away.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I see. Well, I’m glad I found you. You may want to see some of her other things before I remove them. I’ll give you my number. I work at Concordia Publishing nearby, so I can quickly meet you here.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Are you a writer?”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I’m not sure what I am,” she quipped. “I do a bit of everything, but I mostly edit. I get to write things on my own every now and then.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“That is so ironic! When I lived there, I was an editor for Dexter Publishing until I quit. I ended up in retail and living in Augusta, Missouri. I have my own column now with ")]), _c('span', {
    staticClass: "dedication2"
  }, [_vm._v("Spirit")]), _c('span', {
    staticClass: "byline"
  }, [_vm._v(" magazine, so you never know what’s ahead.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“That is fascinating! I would love to meet you. Maybe we could go to lunch when you come.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“I would love to see my old apartment, if that would be okay with you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Of course, and I’ll show you your landlady’s things as well. We can have lunch right here in my apartment.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("“Oh, I don’t want to be any trouble. I’ll give you a call. Thanks so much for contacting me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext3"
  }, [_c('span', {
    staticClass: "byline"
  }, [_vm._v("I sat down to digest what I had just heard. Had Bertie made me a quilt? Was it supposed to have been a gift for me? Meeting Jenny would be exciting. Just imagine: two writers in the same apartment! I could think of so many questions to ask her.")]), _c('span', {
    staticClass: "byline"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d4f2af4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/quilt-left-behind_split8.vue
// module id = 84
// module chunks = 0